module.exports = __webpack_public_path__ + "static/media/logo-without-tagline.caa2daf6.png";